import {
    Box,
    Button,
    Grid,
    makeStyles,
    Typography,
    FormControl,
    Select,
    MenuItem,
  } from "@material-ui/core";
  import instance from "api/globalaxios";
  import Axios from "axios";
  import { format } from "date-fns";
  import CircularCenteredLoader from "features/common/CircularCenteredLoader";
  import debounce from "lodash.debounce";
  import React, { useCallback, useEffect, useState } from "react";
  import { useDispatch } from "react-redux";
  import { useHistory } from "react-router-dom";
import Tabs from "features/Tabs/Tabs";
import { Add, PrintOutlined } from "@material-ui/icons";
import { Pagination } from "@material-ui/lab";
import DropdownButton from "Components/DropdownButton";
import { ARBITRATOR, INDIAN_STATES } from "app/constants";
import SearchBar from "Components/SearchBar";
import Table from "Components/Table/Table";
import DateRangePicker from "Components/DateRangePicker";
import { download_MIS_Report } from "../API/service";
import { isValidNumber, isValidDate, isValidOrixId, calc_days, ALPHANUMERIC_REGEX } from "../utils/util";
import validateDateAndFormat from "utils/validateDateAndFormat";
import fileDownload from "js-file-download";
  
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: "3rem",
      [theme.breakpoints.down("sm")]: {
        padding: "1.5rem",
      },
    },
    typeButton: {
      textTransform: "none",
      border: "1px solid #4F4F4F",
      borderRadius: "0",
      padding: "0 1.5rem",
      color: "#4F4F4F",
      backgroundColor: 'white',
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "18px",
      height: "42px",
  
      [theme.breakpoints.down("xs")]: {
        height: "34px",
        fontSize: "14px",
      },
    },
    typeButtonBlue: {
      textTransform: "none",
      border: "1px solid",
      borderColor: theme.palette.primary.main,
      background: theme.palette.primary.main,
      borderRadius: "0",
      padding: "0 1.5rem",
      color: "#fff",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "18px",
      height: "42px",
      "&:hover": {
        background: "#FFFFFF",
        color: theme.palette.primary.main,
        border: "1px solid",
        borderColor: theme.palette.primary.main,
      },
      [theme.breakpoints.down("xs")]: {
        height: "34px",
        fontSize: "14px",
      },
    },
    typeFormControl: {
      margin: 0,
      "&:hover": {
        background: "#E0E0E0",
      },
    },
    spaceBox: {
      height: "4rem",
      [theme.breakpoints.down("sm")]: {
        height: "3rem",
      },
      [theme.breakpoints.down("xs")]: {
        height: "2rem",
      },
    },
    griditem: {
      padding: "8px",
      [theme.breakpoints.down("xs")]: {
        padding: "4px",
      },
    },

    tabsContainer: {
      width:'70%',
      flexWrap: 'nowrap',
      [theme.breakpoints.down("sm")]: {
        width: '100%',
        flexWrap: 'wrap',
      },
    },
    selected: {
      padding: "0.8rem 1.2rem",
      cursor: 'pointer',
      fontSize: '1.2rem',
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      width: '16.6%',
      textAlign: 'center',
      whiteSpace: 'pre-line',
      color: theme.palette.primary.main,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    unselected: {
      fontSize: '1.2rem',
      padding: "0.8rem 1.2rem",
      cursor: "pointer",
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      width: '16.6%',
      textAlign: 'center',
      whiteSpace: 'pre-line',
      borderBottom: '2px solid black',
    },
    filtersContainer: {
      padding: '1rem 0', 
      display: 'flex', 
      gap: '15px', 
      justifyContent:'center',
      width: '100%',
      margin: 'auto',
    },
    buttonPrint: {
      border: '1px solid #AAAFB9',
      background: '#fff',
      padding: '0.5rem 1rem',
    },
    highlightRow: {
      background: '#2bb87914',
      '& td': {
        fontFamily: 'Satoshi-Bold',
      },
      '& > *:first-child': {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          width: 4,
          background: '#2bb879',
          borderRadius: '2px 0 0 2px',
          display: 'block',
        },
      },
    },
    selectElement: {
      fontSize: '1.2rem', // Sets font size for the selected value
      paddingBottom: '0.7rem',
    },
    underline: {
      '&:before': {
        borderBottom: '2px solid black',
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: '2px solid black', // keeps it black on hover
      },
    },
    tabsContainerToggle: {
      border: '1px solid #858D98',
      width: 'fit-content',
      padding: '0.125rem',
      margin: 'auto 0 auto auto'
      // borderRadius: '0.5rem',
      // [theme.breakpoints.down("sm")]: {
      //   width: '100%',
      //   flexWrap: 'wrap',
      // },
    },
    selectedToggle: {
      padding: "0.6rem 1.25rem",
      cursor: 'pointer',
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
      // borderRadius: '0.5rem',
      color: 'white',
      backgroundColor: theme.palette.primary.main,
    },
    unselectedToggle: {
      padding: "0.6rem 1.25rem",
      cursor: "pointer",
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
      // borderRadius: '0.5rem',
    },
  }));
  
  
  export default function DisputesOrix({
    count,
    disputesLoading,
    setType,
    type,
    disputes,
    reload,
    totalPages,
    currentPage,
    setCurrentPage,
    getUserDataAnotherPage,
    region,
    setRegion,
    profile,
    entity,
    setEntity,
    toggleTab,
    setToggleTab,
  }) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const IS_GRO = profile?.profile?.profile_type === ARBITRATOR;
    const IS_VENDOR = profile?.profile?.profile_type === 'vendor';
    const IS_IO = profile?.profile?.profile_type === 'mediator';
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
  
  
    const [searchText, setSearchText] = useState("");
    const [disputesBySearch, setDisputesBySearch] = useState(disputes);
    const [cancelToken, setCancelToken] = useState();
    let firstname = "";
    let lastname = "";
  
    const debouceSearch = useCallback(debounce(search, 500), [disputes]);

    const columns = [
      { field: 'ticketNumber', headerName: 'Ticket No.', width: '10.33%'},
      { field: 'entity', headerName: 'Entity', width: '6.33%'},
      { field: 'product', headerName: 'Product', width: '16.66%'},
      { field: 'name', headerName: 'Customer Name', width: '15.66 %'},
      { field: 'requestDate', headerName: 'Request Date', width: '14.33%'},
      { field: 'resolveDate', headerName: 'Resolve Date', width: '11.22%'},
      { field: 'daysPasses', headerName: 'Pending Days', width: '8.33%', align: 'center'},
      { field: 'tableStatus', headerName: 'Outcome', width: '16.66%', align: 'center'},
    ];

    const processedData = (data) => {
      const result = data.reduce((arr, item) => {
        const transformedObject = { 
          ticketNumber: item?.grc_ticket_number,
          entity: item?.customer_type,
          product: item?.business_verticle,
          name: item.name, 
          requestDate: format(new Date(item.submission_date), "dd/MM/y, h:mm a"),
          resolveDate: item?.date_closed_by_grc ? format(new Date(item.date_closed_by_grc), "dd/MM/y") : '-',
          daysPasses: item?.date_closed_by_grc ? '-' : calc_days(item.submission_date),
          tableStatus: item?.status,
          is_highlighted: item?.unread?.includes(profile?.profile?.profile_type),
          complainDetails: <Typography className="lineClamp" style={{fontFamily:'inherit'}}>{item?.description}</Typography>, 
          ...item,
        };
        arr.push(transformedObject);
        return arr;
      }, []);
      
      return result;
    };
  
    useEffect(() => {
      setDisputesBySearch(processedData(disputes));
    }, [disputes]);
  
    function search(value, type) {
      //Check if there are any previous pending requests
      if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      let x = Axios.CancelToken.source();
      setCancelToken(x);
  
      if (value.trim() != "") {
        // Input with no letters/digits (e.g. "." or "..") can't match anything, and a
        // dot-only path segment is collapsed by the browser into a 404 -> /fallback.
        if (!ALPHANUMERIC_REGEX.test(value)) {
          setDisputesBySearch([]);
          return;
        }
        let new_value = value.replaceAll('/','-');
        let ar = new_value.trim().split("-");
        let date = new Date(ar[1] + "/" + ar[0] + "/" + ar[2]);
        if (isValidDate(date)) {
          dispatch(getOrixdatabydate(date, x, type, region, entity));
        } else if (isValidNumber(new_value.trim()) || isValidOrixId(new_value.trim())) {
          dispatch(getOrixdatabyDisputeId(new_value.trim(), x, type, region, entity));
        } else {
          let safePath = encodeURIComponent(new_value.trim());
          dispatch(getOrixdatabyname(safePath, x, type, region, entity));
        }
      } else {
        setDisputesBySearch(processedData(disputes));
      }
    }

    function getOrixdatabyname(name, cancelToken, type, region, entity) {
      return async (dispatch) => {
        try {
          // Drop tokens like "." that have no letters/digits; as path segments they get
          // collapsed by the browser and the request 404s.
          const answer_array = name.split(" ").filter((part) => ALPHANUMERIC_REGEX.test(part));
          firstname = encodeURIComponent(answer_array[0]);
          lastname = answer_array[1] && encodeURIComponent(answer_array[1]);
          if (firstname != "" && (lastname == "" || !lastname)) {
            const response2 = await instance.get(
              `/api/orixsearchview/${firstname}/${null}/?type=${type}&region=${region}&days=${'null'}&entity=${entity}`,
              { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
            );
            // console.log(response2.data);
            setDisputesBySearch(processedData(response2.data));
  
            return response2.data;
          } else {
            const response3 = await instance.get(
              `/api/MuthootsearchView/${firstname}/${lastname}/?type=${type}&region=${region}&days=${'null'}`,
              { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
            );
            setDisputesBySearch(processedData(response3.data));
            return response3.data.profiles;
          }
        } catch (error) {
          console.log(error);
          if (!Axios.isCancel(error)) setDisputesBySearch([]);
        }
      };
    }

    function getOrixdatabydate(date, cancelToken, type=null, region=null, entity) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `api/orixsearchbydateView/${format(
              date,
              "dd-MM-yyyy"
            )}/?type=${type}&region=${region}&entity=${entity}`,
            { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
          );
          setDisputesBySearch(processedData(response.data));

          return response.data;
        } catch (error) {
          console.log(error);
          if (!Axios.isCancel(error)) setDisputesBySearch([]);
        }
      };
    }

    function getOrixdatabyDisputeId(value, cancelToken, type, region, entity) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `/api/orixsearchbydisputeidView/${encodeURIComponent(value)}/?type=${type}&region=${region}&days=${'null'}&entity=${entity}`,
            { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
          );
          setDisputesBySearch(processedData(response.data));

          return response.data;
        } catch (error) {
          console.log(error);
          if (!Axios.isCancel(error)) setDisputesBySearch([]);
        }
      };
    }

    const tabs = [
      {
        id: "open",
        label: "Open\n " + count?.[entity]?.open,
      },
      {
        id: "pending_in_grc",
        label: "Pending with GRC\n " + count?.[entity]?.pending_grc,
      },
      {
        id: "pending_in_gro",
        label: "Pending with GRO\n " + count?.[entity]?.pending_gro,
      },
      {
        id: "pending_in_io",
        label: "Pending with IO\n " + count?.[entity]?.pending_io,
      },
    ];

    const [currentTab, setCurrentTab] = useState(type);
    const isDisableClickonRow = (IS_GRO && currentTab === "pending_in_grc") || (IS_IO && (currentTab === "pending_in_grc" || currentTab === "pending_in_gro"));

    const handleTabChange = (newValue) => {
      setCurrentTab(newValue);
      setType(newValue);
      setSearchText("");
      sessionStorage.setItem("muthoot-type", newValue);
      setCurrentPage(1);
      // reload(newValue, region, days);
      // setPagination({
      //   page: 1,
      //   count: activities?.count,
      //   next: activities?.next,
      //   previous: activities?.previous,
      // });
    };

    const handleClickRegionOption = (selectedOption) => {
      const value = selectedOption?.value || selectedOption?.title;
      setRegion((value === region || value === 'Unselect') ? null : value);
    }


    const onRowClick = (row) => {
      if(isDisableClickonRow) return;
      history.push(`/disputes/${row.id}`);
    };
    
    const handleDownloadReport = () => {
      if(startDate > endDate){
        alert("From date should be less than or equal to To date.");
        return;
      }
      download_MIS_Report(validateDateAndFormat(startDate, 'dd-MM-yyyy'),validateDateAndFormat(endDate, 'dd-MM-yyyy')).then((res)=>{
        // console.log(res);
        fileDownload(
          res.data,
          `MIS_Report_${validateDateAndFormat(startDate, 'dd-MM-yyyy')}_to_${validateDateAndFormat(endDate, 'dd-MM-yyyy')}.xlsx`
        );
      }).catch((error)=>{
        console.log(error);
      })
    }

    const toggleTabs = [
      {
        id: "GRC",
        label: "From GRC " + count?.[entity]?.pending_gro_from_grc,
      },
      {
        id: "IO",
        label: "From IO " + count?.[entity]?.pending_gro_from_io,
      },
    ];

    const handleToggleTabChange = (newValue) => {
      setToggleTab(newValue);
    };

    const ENTITY_DROPDOWN = ['OLFS', 'OCIL'];

    return (
      <>
        <Grid container className={classes.root}>
          <Grid container justify="space-between" alignItems="center" style={{gap: '1rem'}}>
            <div style={{display:'flex', alignItems: 'flex-end', flex: 1}}>
              <FormControl key="type" fullWidth size="large" style={{maxWidth:'100px'}}>
                <Typography style={{fontSize:'1.2rem'}}>Entity</Typography>
                <Select
                  required
                  id="type"
                  name="type"
                  value={entity}
                  onChange={(e) => setEntity(e.target.value)}
                  className={classes.underline}
                  inputProps={{
                    classes: {
                      root: classes.selectElement, // Apply font size logic
                    },
                  }}
                >
                  {ENTITY_DROPDOWN.map((type, index) => (
                    <MenuItem key={index} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Tabs
                tabs={tabs}
                handleClickTab={handleTabChange}
                choice={currentTab}
                tabsClasses={{
                  selected: classes.selected,
                  unselected: classes.unselected,
                }}
                tabsContainerClass={(IS_VENDOR)?classes.tabsContainer:{width:'100%'}}
              />
            </div>
            <Typography
              color="primary"
              style={{textDecoration:'underline', cursor:'pointer'}}
              onClick={() => {
                handleTabChange("closed");
              }}
            >
              View Closed Grievances
            </Typography>
            {(IS_VENDOR) && (
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add/>}
                  onClick={() => {
                    history.push("/intro");
                  }}
                >
                  CREATE TICKET
                </Button>
              </Box>
            )}
          </Grid>
          <Box className={classes.spaceBox} />
          {disputesLoading ? (
            <CircularCenteredLoader />
          ) : (
            <>
              <Grid container>
                <Grid
                  item
                  className={classes.griditem}
                  style={{ paddingLeft: 0, flex: 1, }}
                >
                  <SearchBar
                    placeholder="Search by Complainant's Name, Date (DD-MM-YYYY) or Ticket Number"
                    value={searchText}
                    onChange={(value) => {
                      setSearchText(value);
                      debouceSearch(value, type);
                    }}
                    backgroundColor="#f5f5f5"
                    height={42}
                    borderRadius={0}
                    showSearchIcon={true}
                    TextFieldProps={{
                      fullWidth: true,
                    }}
                  />
                </Grid>
                <Grid item className={classes.griditem} style={{ paddingRight: 0}}>
                  <DropdownButton
                    buttonText={region ? region : 'Region'}
                    options={[{ title: 'Unselect' }, ...INDIAN_STATES.map(item => ({ title: item }))]}
                    classes={classes}
                    handleClickOption={handleClickRegionOption}
                    selectedOption={region}
                  />
                </Grid>
              </Grid>
              <Box className={classes.filtersContainer} style={{justifyContent:'space-between'}}>
                <DateRangePicker 
                  startDate={startDate} 
                  setStartDate={setStartDate} 
                  endDate={endDate} 
                  setEndDate={setEndDate}
                  maximumStartDate={new Date()}
                  maximumEndDate={new Date()}
                />
                <Button
                  className={classes.buttonPrint}
                  endIcon={<PrintOutlined/>}
                  onClick={handleDownloadReport}
                  disabled={!startDate || !endDate}
                  size="small"
                >
                  Download Report
                </Button>
              </Box>
              {(IS_GRO && currentTab === 'pending_in_gro') && (
                <Tabs
                  tabs={toggleTabs}
                  handleClickTab={handleToggleTabChange}
                  choice={toggleTab}
                  tabsClasses={{
                    selected: classes.selectedToggle,
                    unselected: classes.unselectedToggle,
                  }}
                  tabsContainerClass={classes.tabsContainerToggle}
                />
              )}
              {/* Disputes list starts from here */}
              <Box className={classes.spaceBox}></Box>
              <Grid container style={{ rowGap: "8px" }}>
                
                {disputesBySearch.length !== 0 ? (
                  <Table
                    data={disputesBySearch}
                    columns={columns}
                    onRowClick={onRowClick}
                    loading={disputesLoading}
                    customStyles={{ 
                      tableStyle: { marginTop: '2%', border: '1px solid #e0e0e0'},
                      rowStyle: { cursor: isDisableClickonRow ? 'default' : 'pointer' }, 
                      headerCellStyle: { fontFamily: 'Satoshi-Bold', padding: '0.75rem' }, 
                      cellStyle: { fontSize: '1rem', padding: '0.75rem' }
                    }}
                    getTableRowClassName={(highlight)=> highlight ? classes.highlightRow : ''}
                  />
                ) : (
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Box textAlign="center">
                        <Typography
                          style={{
                            fontFmaily: '"Inter","sans-serif"',
                            fontWeight: 500,
                            fontSize: "initial",
                          }}
                        >
                          Dispute does not exist.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Box height="10px"></Box>
              {disputesBySearch.length !== 0 && !searchText && (
                <div style={{display: 'flex', justifyContent: 'flex-end', padding: '1rem 0', width: '100%'}}>
                  <Pagination color="primary" page={currentPage} count={totalPages} onChange={(event, value)=>getUserDataAnotherPage(value)}/>
                </div>
              )}
            </>
          )}
        </Grid>
      </>
    );
  }

  
  